import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
import CardCount from "../../../components/CardCount";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { Grid, Checkbox, FormControlLabel } from "@mui/material";
import { Group as StudentIcon, Class as ClassIcon, EmojiPeople as TeacherIcon } from "@mui/icons-material";
import NoRecentUsers from "../../../assets/images/nofeatureicons/norecentuser.svg";
import Table from "../../../components/Table/Table";
import useStyles from "../styles";
import { TableSearch } from "../../../components/Table/TableActions";
import { Gender } from "../../../utils/DropDown";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Select from "react-select";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import useValidator from "../../../hooks/useValidator";
import { useUserState } from "../../../context/UserContext";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";

// const HOSTEL_ENDPOINT = "api/v1";
const EMPLOYEES_ENDPOINT = "api/v1/employees";
// const CLASS_ENDPOINT = "/api/v1/class";
const STUDENT_ENDPOINT = "/api/v1/students";
const HOSTEL_ENDPOINT = "/api/v1/hostel-management/hostel-overview";
const ALL_HOSTEL_ENDPOINT = "/api/v1/hostel-management/all-hostels";
const CREATE_HOSTEL_ENDPOINT = "/api/v1/hostel-management/create-hostel";
const HOSTEL_EDIT_ENDPOINT = "/api/v1/hostel-management/hostel";
const HOSTEL_ROOM = "/api/v1/hostel-management/hostel-rooms/";
const ALLOCATE_ENDPOINT = "/api/v1/hostel-management/hostels/allocate";

const AdminHostel = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { userRole } = useUserState();
  const [itemModal, setItemModal] = useState(false);
  const [isHostelCreating, setIsHostelCreating] = useState(false);
  const [isHostelEditing, setIsHostelEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isHostelEditingModal, setIsHostelEditingModal] = useState(false);
  const [allocate, setAllocate] = useState(false);
  const [deleteHostelModal, setDeleteHostelModal] = useState(false);
  const [isAllocating, setISAllocating] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [hostelOverview, setHostelOverview] = useState([]);
  const [allHostelRoom, setAllHostelRoom] = useState([]);
  const [overViewLoading, setOverViewLoading] = useState([]);
  const [createHostelValidator, showCreateEventValidator] = useValidator();
  const [editHostelValidator, showEditHostelValidator] = useValidator();
  const [allocateHostelValidator, showAllocateHostelValidator] = useValidator();
  const [allHostels, setAllHostels] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  // const [classData, setClassData] = useState([]);
  const [studentData, setStudentsData] = useState([]);
  const [currentRow, setCurrentRow] = useState({});
  const width = useWindowSize();
  const mobile = width < 600;
  const [allocations, setAllocations] = useState(
    {
      hostel_id: "",
      // class_id: "",
      students: [],
      room_id: "",
      allocated_by: userRole?.id
    }
  );

  const [createHostelForm, setCreateHostelForm] = useState({
    name: "",
    gender: "",
    hostel_master_id: "",
    number_of_rooms: "",
    students_per_room: "",
    create_group_chat: false
  });
  const [editCreateHostelForm, setEditCreateHostelForm] = useState({
    name: "",
    gender: "",
    hostel_master_id: "",
    number_of_rooms: "",
    students_per_room: ""
  });

  const handleEditHostelRow = (row) => {
    setCurrentRow(row);
    setEditCreateHostelForm({
      ...editCreateHostelForm,
      name: row?.name,
      gender: row?.gender,
      hostel_master_id: row?.hostel_master?.id,
      number_of_rooms: row?.number_of_rooms,
      students_per_room: row?.students_per_room
    });
    setIsHostelEditingModal(true);
  };

  const handleDeleteHostelRow = (row) => {
    setCurrentRow(row);
    setDeleteHostelModal(!deleteHostelModal);
  };

  const handleCreateHostelChange = (e) => {
    const { name, value } = e.target;
    setCreateHostelForm({ ...createHostelForm, [name]: value });
  };
  const handleEditHostelChange = (e) => {
    const { name, value } = e.target;
    setEditCreateHostelForm({ ...editCreateHostelForm, [name]: value });
  };

  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
    setCreateHostelForm({
      name: "",
      gender: "",
      hostel_master_id: "",
      number_of_rooms: "",
      students_per_room: "",
      create_group_chat: false
    });
  };
  const handleOpenAllocateModal = () => {
    setAllocate(!allocate);
  };

  const handleCloseAllocateModal = () => {
    setAllocate(false);
    setAllocations({
      hostel_id: "",
      // class_id: "",
      students: [],
      room_id: "",
      allocated_by: userRole?.id
    });
  };
  const recentUser = [
    {
      name: "Hostel Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Hostel Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Type",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Type</p>}
          {row?.gender || "--/--"}
        </>
      )
    },
    {
      name: "Hostel Master",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Hostel Master</p>}
          {`${row?.hostel_master?.last_name || "--/--"} ${row?.hostel_master?.first_name || "--/--"}`}
        </>
      )
    },
    // {
    //   name: "Room Capacity",
    //   selector: (row) => (
    //     <>
    //       {mobile && <p className="mobile-styling">Room Capacity</p>}
    //       {row?.students_per_room || "--/--"}
    //     </>
    //   )
    // },
    {
      name: "Number of rooms",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Number of rooms</p>}
          {row?.number_of_rooms || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => navigate(`/hostel/${row?.id}`)}
            className="table-action-icon"
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => handleEditHostelRow(row)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => handleDeleteHostelRow(row)}
          >
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  /**
     * Fetches all classes in the school.
     */
  const getAllHostelRoom = (hostel_id) => {
    httprequest.get(`${HOSTEL_ROOM}${hostel_id}`).then((res) => {
      setAllHostelRoom(res?.data?.rooms);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleAllocateHostelChange = (e) => {
    const { name, value } = e.target;

    // If hostel_id changes, fetch hostel rooms
    if (name === "hostel_id" && value) {
      getAllHostelRoom(value);
    }

    // Update the allocations state
    setAllocations((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  /**
   * Fetches all students and separates them into active/inactive categories.
   * Also handles loading state and error toasts.
   */
  const getAllStudents = () => {
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
      setStudentsData(res?.data?.data?.filter((active_stn) => active_stn?.is_active === true)?.map((stdn) => {
        return {
          label: `${stdn?.student?.last_name} ${stdn?.student?.first_name}`,
          value: stdn?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Fetches all classes in the school.
   */
  // const getAllClasses = () => {
  //   httprequest.get(CLASS_ENDPOINT).then((res) => {
  //     setClassData(res?.data?.data);
  //   }).catch((err) => {
  //     toast.error(err?.response?.data);
  //   });
  // };

  /**
   * Fetches all classes in the school.
   */
  const getHostelOverview = () => {
    setOverViewLoading(true);
    httprequest.get(HOSTEL_ENDPOINT).then((res) => {
      setOverViewLoading(false);
      setHostelOverview(res?.data?.data);
    }).catch((err) => {
      setOverViewLoading(false);
      toast.error(err?.response?.data);
    });
  };

  /**
   * Fetches all classes in the school.
   */
  const getAllHostels = () => {
    httprequest.get(ALL_HOSTEL_ENDPOINT).then((res) => {
      setAllHostels(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleCreateHostel = () => {
    if (createHostelValidator.allValid()) {
      setIsHostelCreating(true);
      httprequest.post(CREATE_HOSTEL_ENDPOINT, createHostelForm).then((res) => {
        setIsHostelCreating(false);
        toast.success(res?.data?.message);
        handleOpenItemMOdal();
        getAllHostels();
        getHostelOverview();
      }).catch((err) => {
        setIsHostelCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showCreateEventValidator(true);
    }
  };

  const handleCloseEditModal = () => {
    setCurrentRow({});
    setIsHostelEditingModal(!isHostelEditingModal);
  };

  const handleEditHostel = () => {
    if (editHostelValidator.allValid()) {
      setIsHostelEditing(true);
      httprequest.patch(`${HOSTEL_EDIT_ENDPOINT}/${currentRow?.id}`, editCreateHostelForm).then((res) => {
        setIsHostelEditing(false);
        toast.success(res?.data?.message);
        handleCloseEditModal();
        getAllHostels();
        getHostelOverview();
      }).catch((err) => {
        setIsHostelEditing(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEditHostelValidator(true);
    }
  };

  const handleAllocateHostel = () => {
    if (allocateHostelValidator.allValid()) {
      setISAllocating(true);
      const payload = {
        allocate_students: [allocations]
      };
      httprequest.post(ALLOCATE_ENDPOINT, payload).then((res) => {
        setISAllocating(false);
        toast.success(res?.data?.message);
        handleCloseAllocateModal();
        getAllHostels();
        getHostelOverview();
      }).catch((err) => {
        setISAllocating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showAllocateHostelValidator(true);
    }
  };

  const handleDeleteHostel = () => {
    setIsDeleting(true);
    httprequest.delete(`${HOSTEL_EDIT_ENDPOINT}/${currentRow?.id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      getAllHostels();
      getHostelOverview();
      setDeleteHostelModal(!deleteHostelModal);
      setCurrentRow({});
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleStudentChange = (selectedOptions) => {
    const studentIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setAllocations((prev) => ({
      ...prev,
      students: studentIds
    }));
  };

  /**
   * Fetches employee data from the server based on the selected `value` (e.g., staff status).
   * Updates the employee state and loading state accordingly.
   *
   * @function getEmployeeData
   */
  const getEmployeeData = () => {
    httprequest.get(`${EMPLOYEES_ENDPOINT}`).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  useEffect(() => {
    getEmployeeData();
    // getAllClasses();
    getAllStudents();
    getHostelOverview();
    getAllHostels();
  }, []);

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = allHostels?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.gender
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.hostel_master?.last_name
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.hostel_master?.email
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.hostel_master?.first_name
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <>
      <PageTitle
        title="Hostel Management"
        subtitle="Manage hostel details, rooms, and student allocations."
        button={
          <div className="flex gap-10 button_tab">
            {/* <PopModal title="hostel" videoUrl="" /> */}
            <Button
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              onClick={handleOpenAllocateModal}
              buttonName="Allocate Hostel"
            />
            {userRole?.role === "school_admin" && (
              <>
                <Button
                  variant="primary"
                  buttonSize="small"
                  color="btndefault"
                  onClick={handleOpenItemMOdal}
                  buttonName="Create Hostel"
                />
              </>
            )}
          </div>
        }
      />
      {overViewLoading ? (
        <PageLoader />
      ) : (
        <Grid container spacing={4} sx={{ marginTop: "10px" }}>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <CardCount
              title="Number of Hostels"
              count={hostelOverview?.total_hostels || 0}
              icon={<StudentIcon />}
              leftSubText="Male :"
              rightSubText="Female :"
              leftSubValue={hostelOverview?.male_hostels || 0}
              rightSubValue={hostelOverview?.female_hostels || 0}
            />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <CardCount
              title="Number of Students"
              count={hostelOverview?.total_students || 0}
              icon={<TeacherIcon />}
              leftSubText="Male :"
              rightSubText="Female :"
              leftSubValue={hostelOverview?.male_students || 0}
              rightSubValue={hostelOverview?.female_students || 0}
            />
          </Grid>
          <Grid item lg={4} md={4} sm={6} xs={12}>
            <CardCount
              title="Number of Rooms"
              count={hostelOverview?.total_rooms || 0}
              icon={<ClassIcon />}
              leftSubText="Allocated :"
              rightSubText="Unallocated :"
              leftSubValue={hostelOverview?.allocated_students || 0}
              rightSubValue={hostelOverview?.unallocated_students || 0}
            />
          </Grid>
        </Grid>
      )}
      <div className="page-content margin-top-16     ">
        {allHostels?.length > 0 ? (
          <Table data={searchResult} columns={recentUser} subHeader={true} pagination subHeaderComponent={
            <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInventory} />
          }
          />
        ) : (
          <div className={classes.notfound}>
            <NoData
              img={NoRecentUsers}
              title="No Hostel Found"
              subtitle="No hostel has been created or added"
            />
          </div>
        )}
      </div>

      {/* Create Hostels */}
      <Modal
        title="Create Hostels"
        subtitle={
          <div>
                Create a new hostel by filling in the details below.
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Hostel Name"
                  margin="normal"
                  inputType="text"
                  required
                  inputName="name"
                  onChange={handleCreateHostelChange}
                />
                {createHostelValidator.message("Hostel Name", createHostelForm?.name, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Hostel Type (Gender)"
                  required
                  children={
                    <select onChange={handleCreateHostelChange} name="gender">
                      <option value="">--- Select ---</option>
                      {Gender?.map((gender) => {
                        return (
                          <option key={gender.key} value={gender?.key}>
                            {gender?.text}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {createHostelValidator.message("Hostel Name", createHostelForm?.gender, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Hostel Master"
                  required
                  children={
                    <select onChange={handleCreateHostelChange} name="hostel_master_id">
                      <option value="">--- Select ---</option>
                      {employeesData?.map((employee) => {
                        return (
                          <option key={employee?.user_id} value={employee?.user_id}>
                            {`${employee?.first_name} ${employee?.last_name}`}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {createHostelValidator.message("Hostel Name", createHostelForm?.hostel_master_id, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Number of Rooms"
                  margin="normal"
                  inputType="number"
                  required
                  inputName="number_of_rooms"
                  onChange={handleCreateHostelChange}
                />
                {createHostelValidator.message("Hostel Name", createHostelForm?.number_of_rooms, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Average Room Capacity"
                  margin="normal"
                  inputType="number"
                  required
                  inputName="students_per_room"
                  onChange={handleCreateHostelChange}
                />
                {createHostelValidator.message("Hostel Name", createHostelForm?.students_per_room, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={createHostelForm.create_group_chat ?? false}
                      onChange={(e) => setCreateHostelForm((prev) => ({
                        ...prev,
                        create_group_chat: e.target.checked
                      }))
                      }
                      color="primary"
                    />
                  }
                  label="Create General Group Chats"
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Create Hostel"
                onClick={handleCreateHostel}
                isLoading={isHostelCreating}
              />
            </div>
          </>
        }
        isopen={itemModal}
        closeModal={handleOpenItemMOdal}
      />
      {/* Allocate Hostel */}
      <Modal
        title="Alocate Hostels"
        subtitle={
          <div>
                Allocate a hostel to a student by filling in the details below.
          </div>
        }
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Hostel"
                  required
                  children={
                    <select onChange={handleAllocateHostelChange} name="hostel_id">
                      <option value="">--- Select ---</option>
                      {allHostels?.map((hostel) => {
                        return (
                          <option key={hostel?.id} value={hostel?.id}>
                            {hostel?.name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {allocateHostelValidator.message("Hostel", allocations?.hostel_id, "required")}
              </Grid>
              {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Class"
                  required
                  children={
                    <select onChange={handleAllocateHostelChange} name="class_id">
                      <option value="">--- Select ---</option>
                      {classData?.map((classes) => {
                        return (
                          <option key={classes?.id} value={classes?.id}>
                            {classes?.class_name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {allocateHostelValidator.message("Class", allocations?.class_id, "required")}
              </Grid> */}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <div className="multiple-select">
                  <p>Students</p>
                  <Select
                    name="students"
                    options={studentData}
                    placeholder="Select a student"
                    isMulti
                    isClearable
                    onChange={handleStudentChange}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </div>
                {allocateHostelValidator.message("Students", allocations?.students, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Room Number"
                  required
                  children={
                    <select onChange={handleAllocateHostelChange} name="room_id">
                      <option value="">--- Select ---</option>
                      {allHostelRoom?.map((room) => {
                        return (
                          <option key={room.id} value={room?.id}>
                            {room?.name}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {allocateHostelValidator.message("Hostel Room", allocations?.room_id, "required")}
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Allocate Hostel"
                onClick={handleAllocateHostel}
                isLoading={isAllocating}
              />
            </div>
          </>
        }
        isopen={allocate}
        closeModal={handleCloseAllocateModal}
      />
      {/* Edit Hostel Modal */}
      <Modal
        title={`Edit ${currentRow?.name} Hostel`}
        subtitle={`Edit details of ${currentRow?.name} Hostel `}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Hostel Name"
                  margin="normal"
                  inputType="text"
                  required
                  inputName="name"
                  defaultValue={currentRow?.name}
                  onChange={handleEditHostelChange}
                />
                {editHostelValidator.message("Hostel Name", editCreateHostelForm?.name, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Hostel Type (Gender)"
                  required
                  children={
                    <select defaultValue={currentRow?.gender} onChange={handleEditHostelChange} name="gender">
                      <option value="">--- Select ---</option>
                      {Gender?.map((gender) => {
                        return (
                          <option key={gender.key} value={gender?.key}>
                            {gender?.text}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {editHostelValidator.message("Gender", editCreateHostelForm?.gender, "required")}
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <SelectGroup
                  label="Hostel Master"
                  required
                  children={
                    <select value={currentRow?.hostel_master?.id} onChange={handleEditHostelChange} name="hostel_master_id">
                      <option value="">--- Select ---</option>
                      {employeesData?.map((employee) => {
                        return (
                          <option key={employee?.user_id} value={employee?.user_id}>
                            {`${employee?.first_name} ${employee?.last_name}`}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {editHostelValidator.message("Hostel Master", editCreateHostelForm?.hostel_master_id, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Number of Rooms"
                  margin="normal"
                  inputType="number"
                  required
                  inputName="number_of_rooms"
                  onChange={handleEditHostelChange}
                  defaultValue={currentRow?.number_of_rooms}
                />
                {editHostelValidator.message("Number of Rooms", editCreateHostelForm?.number_of_rooms, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Room Capacity"
                  margin="normal"
                  inputType="number"
                  required
                  inputName="students_per_room"
                  onChange={handleEditHostelChange}
                  defaultValue={currentRow?.students_per_room}
                />
                {editHostelValidator.message("Room Capacity", editCreateHostelForm?.students_per_room, "required")}
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              onClick={handleEditHostel}
              variant="primary"
              buttonName="Edit Hostel"
              buttonSize="full"
              color="btndefault"
              isLoading={isHostelEditing}
            />
          </>
        }
        isopen={isHostelEditingModal}
        closeModal={handleCloseEditModal}
      />

      {/* Delete Modal */}
      <Modal
        title="Delete Hostel"
        subtitle={`Are you sure you want to delete  ${currentRow?.name} hostel.`}
        modalContent={
          <>
            <div>
            </div>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              variant="danger"
              buttonName="Delete Hostel"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeleteHostel}
              isLoading={isDeleting}
            />
          </>
        }
        isopen={deleteHostelModal}
        closeModal={handleDeleteHostelRow}
      />
      {/* <ToastContainer /> */}
    </>
  );
};

export default AdminHostel;
